import { NodeUtils } from '@ssml-editor/vue';
import { SPEAK_TYPE } from './constant.js';

function setTextFromPlaceholder(htmlElement) {
  if (htmlElement) {
    const placeholderElement = htmlElement.querySelector(
      '[data-slate-placeholder="true"]'
    );
    if (placeholderElement) {
      placeholderElement.parentElement?.querySelector('[data-slate-length="0"]')?.setAttribute("data-text", placeholderElement.textContent);
    }
  }
}
const speakPlugin = (editor) => {
  const { isInline, isVoid } = editor;
  const newEditor = editor;
  newEditor.isInline = (element) => {
    const type = NodeUtils.getNodeType(element);
    if (type === SPEAK_TYPE) return false;
    return isInline(element);
  };
  newEditor.isVoid = (element) => {
    const type = NodeUtils.getNodeType(element);
    if (type === SPEAK_TYPE) return false;
    return isVoid(element);
  };
  newEditor.once(
    "created",
    (_eventName, _editor, htmlElement) => {
      setTextFromPlaceholder(htmlElement);
    }
  );
  newEditor.on(
    "valueChange",
    (_eventName, _editor, htmlElement) => {
      setTextFromPlaceholder(htmlElement);
    }
  );
  return newEditor;
};

export { speakPlugin };
//# sourceMappingURL=plugin.js.map
